<script>

  import CardBase from '@/components/CardBase'
  import CardImage from '@/components/CardImage'

  export default {
    components: {
      CardBase,
      CardImage,
    },
    props: {
      post: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        imageSettings: '?w=480&h=360&fm=jpg&fit=fill&fl=progressive&q=80'
      }
    },
    computed: {
      fields () {
        return this.post.fields
      },
      date () {
        if (!this.post.fields.publishDate || this.post.fields.category.fields.slug !== 'nieuws') return ''
        return this.$dateFns.format(this.post.fields.publishDate, 'dd MMM yyyy')
      },
      image () {
        if (!this.fields.featuredImage) return ''
        return 'https:' + this.fields.featuredImage.fields.file.url + this.imageSettings
      },
      alt () {
        if (!this.image) return ''
        return this.fields.featuredImage.fields.description
      },
      postLink () {
        return '/artikel/' + this.fields.slug
      }
    }
  }
</script>

<template>
  <card-base class="card-article">
    <nuxt-link :to="postLink">
      <div class="card-image relative">
        <card-image
          aspect-ratio="4-3"
          :image="image"
          :alt="alt"
        />
        <span class="absolute top-4 right-4 rounded-sm bg-white py-1.5 px-1 text-xs font-semibold text-gray-800">
          {{ fields.category.fields.title }}
        </span>
        <h3
          class="absolute bottom-4 left-4 right-4 bg-white p-4 rounded-lg font-primary text-base leading-normal flex items-center"
          :title="fields.title"
        >
          {{ fields.title }}
          <span class=" text-blue-500 w-5 h-5">          
            <q-icon
              name="chevron-right-blue"
              class="ml-2 text-sm"
            />
          </span>
        </h3>
      </div>
    </nuxt-link>
  </card-base>
</template>

<style lang="scss">

  .card-article {

    .card-content {
      @apply flex flex-col justify-between bg-white p-6 h-40;

      h3 {
        @apply overflow-hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }

    }

  }

</style>
